import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export const PLANNING_GRID_VALIDATION_RULES = {
  pauseEnd: {
    isValid(value, row) {
      const pauseStart = dayjs(row?.pauseStart);
      const pauseEnd = dayjs(value);
      const validDates = pauseStart.isValid() && pauseEnd.isValid();
      if (validDates) {
        // isEndPrevBiggerOrEqualThanStartPrev
        return pauseEnd.isSameOrAfter(pauseStart, 'day');
      }
      return false;
    },
    errorText: 'Preenchimento inválido',
  },
  endReplan: {
    isValid(value, row) {
      const startReplan = dayjs(row?.startReplan);
      const endReplan = dayjs(value);
      const validDates = startReplan.isValid() && endReplan.isValid();
      if (validDates) {
        // isEndPrevBiggerOrEqualThanStartPrev
        return endReplan.isSameOrAfter(startReplan, 'day');
      }
      return false;
    },
    errorText: 'Preenchimento inválido',
  },
  frequency: {
    isValid(value) {
      return Number(value) >= 0;
    },
    errorText: 'Preenchimento inválido',
  },
  conclusion: {
    isValid(value) {
      return Number(value) >= 0 && Number(value) <= 100;
    },
    errorText: 'Preenchimento inválido',
  },
  report: {
    isValid(value) {
      if (value) {
        return Boolean(
          `${value}`.match(
            // url regex
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
          ),
        );
      }

      return true;
    },
    errorText: 'Preenchimento inválido',
  },
};

export const CORRECTIVES_GRID_VALIDATION_RULES = {
  justificationId: {
    isValid(value, row) {
      if (value) return true;

      const forecastReturn = row?.forecastReturn;
      const occurrenceDate = dayjs(row?.occurrence);
      const currentDate = dayjs();
      const diffInDays = currentDate.diff(occurrenceDate, 'day');

      const isBiggerThanFiveDays = diffInDays > 5; // (5 dias)

      return Boolean(forecastReturn) && !isBiggerThanFiveDays;
    },
    errorText: 'Campo obrigatório',
  },
  forecastReturn: {
    isValid(value) {
      const forecastReturn = dayjs(value);
      const minDate = dayjs();
      const validDates = forecastReturn.isValid();
      if (validDates) {
        return forecastReturn.isSameOrAfter(minDate, 'day');
      }
      return false;
    },
    errorText: 'Preenchimento inválido',
  },
};

export const CHROMATOGRAPHIC_GRID_VALIDATION_RULES = {
  omegaRecommendation: {
    isValid(value) {
      return value.length <= 500;
    },
    errorText: 'Texto ultrapassou o limite de 500 caracteres',
  },
};

export const CHEMICAL_PHYSICAL_GRID_VALIDATION_RULES = {
  omegaRecommendation: {
    isValid(value) {
      return value.length <= 500;
    },
    errorText: 'Texto ultrapassou o limite de 500 caracteres',
  },
};

export const STOCK_POSITION_GRID_VALIDATION_RULES = {
  itemDescription: {
    isValid(value) {
      return String(value).length <= 200;
    },
    errorText: 'Texto ultrapassou o limite de 200 caracteres',
  },
  materialClass: {
    isValid(value) {
      return Boolean(value);
    },
    errorText: 'Preenchimento inválido',
  },
  group: {
    isValid(value) {
      return Boolean(value);
    },
    errorText: 'Preenchimento inválido',
  },
  minimumQuantity: {
    isValid(value, row) {
      const { maximumQuantity = 0 } = row;

      return Number(value) >= 0 && Number(value) <= Number(maximumQuantity);
    },
    errorText: 'Preenchimento inválido',
  },
  maximumQuantity: {
    isValid(value) {
      return Number(value) <= 1e4;
    },
    errorText: 'Preenchimento inválido',
  },
  currentQuantity: {
    isValid(value) {
      return Number(value) >= 0;
    },
    errorText: 'Preenchimento inválido',
  },
  leadtime: {
    isValid(value) {
      return Number(value) >= 0 && Number(value) <= 1e3;
    },
    errorText: 'Preenchimento inválido',
  },
  lifespan: {
    isValid(value) {
      return Number(value) >= 0 && Number(value) <= 1e3;
    },
    errorText: 'Preenchimento inválido',
  },
  validity: {
    isValid(value) {
      return dayjs(value).isValid();
    },
    errorText: 'Preenchimento inválido',
  },
  situation: {
    isValid(value) {
      return Boolean(value);
    },
    errorText: 'Preenchimento inválido',
  },
  oracleCode: {
    // opcional
    isValid(value) {
      if (value) return String(value).length <= 45;

      return true;
    },
    errorText: 'Preenchimento inválido',
  },
};

export const GROUP_PERMISSION_GRID_VALIDATION_RULES = {
  group: {
    isValid(value) {
      return Boolean(value);
    },
    errorText: 'Preenchimento inválido',
  },
};
